import { render, staticRenderFns } from "./AddModalV3.vue?vue&type=template&id=296777d1&scoped=true&"
import script from "./AddModalV3.vue?vue&type=script&lang=ts&"
export * from "./AddModalV3.vue?vue&type=script&lang=ts&"
import style0 from "./AddModalV3.vue?vue&type=style&index=0&id=296777d1&lang=scss&scoped=true&"
import style1 from "./AddModalV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296777d1",
  null
  
)

export default component.exports